import * as React from 'react'
import { IconName } from '../../../lib/constants'
import { Icon } from '../Icon'
import { NavigationLink } from '../NavigationLink'
import { AnnouncementBannerLinkStyled, Container, Group, IconWrapper, NavList, Text, Wrapper } from './styled'
import { AnnouncementBannerProps } from './types'

export const AnnouncementBanner = ({ children }: AnnouncementBannerProps) => {
  return (
    <Wrapper>
      <Container>
        <NavList>{children}</NavList>
      </Container>
    </Wrapper>
  )
}

export const AnnouncementBannerGroup = Group
export const AnnouncementBannerLink = ({
  as,
  children,
  isActive,
  useTheme,
  icon,
  isFullWidth,
  ...rest
}: {
  as?: React.ElementType
  children: React.ReactNode
  isActive?: boolean
  useTheme?: boolean
  icon?: IconName
  isFullWidth?: boolean
  [key: string]: any
}) => {
  return (
    <NavigationLink
      activeClassName="active"
      isActive={isActive}
      useTheme={useTheme}
      as={as}

      isFullwidth={isFullWidth}
      {...rest}
    >
      <AnnouncementBannerLinkStyled>
        <Text>{children}</Text>
        {icon && (
          <IconWrapper>
            <Icon name={icon} iconSize="20px" />
          </IconWrapper>
        )}
      </AnnouncementBannerLinkStyled>
    </NavigationLink>
  )
}
